var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('BannerPrincipal'),_c('Banner2'),_c('Banner3'),_c('Banner4'),_c('BannerIndicadores'),_c('Banner6'),_c('Banner7'),_c('Banner8'),_c('Banner9'),_c('Banner10'),_c('bannerFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }